import type {Prompt} from '@cp/model';
import {useCallback, useState} from 'react';
import {promptsGenerateQuestionGraphJson} from '../../api/callable/prompts';

export interface GenerateQuestionGraphJsonPromptsVariables {
  questionText: string;
  topic?: string;
  difficulty?: number;
  hint?: string;
  options?: string[];
  answer?: string;
  explanation?: string;
}

export function useGenerateQuestionGraphJsonPrompts() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateQuestionGraphJsonPrompts = useCallback(
    async (variables: GenerateQuestionGraphJsonPromptsVariables): Promise<Prompt> => {
      setLoading(true);
      setError(undefined);
      try {
        return await promptsGenerateQuestionGraphJson(variables);
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    generateQuestionGraphJsonPrompts,
    loading,
    error,
  };
}
